import axios from 'axios'
import { getDataAtual } from '@/tools/tools'

export default {
  namespaced: true,
  state: {
    lista: [],
    filtroLote: '',
    filtroFormulaId: null,
    filtroSituacao: '',
    dt1: getDataAtual(),
    dt2: getDataAtual(),
    tipoData: 'C',
    registroSelecionadoId: null,
    paginaAtual: 1,
    recarregarLista: false,
    processoAtual: null,
    itensProcesso: []
  },
  getters: {
    LISTA: state => state.lista,
    FILTRO_LOTE: state => state.filtroLote,
    FILTRO_FORMULA_ID: state => state.filtroFormulaId,
    FILTRO_SITUACAO: state => state.filtroSituacao,
    DT1: state => state.dt1,
    DT2: state => state.dt2,
    TIPO_DATA: state => state.tipoData,
    REGISTRO_SELECIONADO_ID: state => state.registroSelecionadoId,
    PAGINA_ATUAL: state => state.paginaAtual,
    RECARREGAR_LISTA: state => state.recarregarLista,
    PROCESSO_ATUAL: state => state.processoAtual,
    ITENS_PROCESSO: state => state.itensProcesso
  },
  mutations: {
    SET_LISTA(state, payload) {
      state.lista = payload
    },
    SET_FILTRO_LOTE(state, payload) {
      state.filtroLote = payload
    },
    SET_FILTRO_FORMULA_ID(state, payload) {
      state.filtroFormulaId = payload
    },
    SET_FILTRO_SITUACAO(state, payload) {
      state.filtroSituacao = payload
    },
    SET_DT1(state, payload) {
      state.dt1 = payload
    },
    SET_DT2(state, payload) {
      state.dt2 = payload
    },
    SET_TIPO_DATA(state, payload) {
      state.tipoData = payload
    },
    SET_REGISTRO_SELECIONADO_ID(state, payload) {
      state.registroSelecionadoId = payload
    },
    SET_PAGINA_ATUAL(state, payload) {
      state.paginaAtual = payload
    },
    SET_RECARREGAR_LISTA(state, payload) {
      state.recarregarLista = payload
    },
    SET_PROCESSO_ATUAL(state, payload) {
      state.processoAtual = payload
    },
    SET_ITENS_PROCESSO(state, payload) {
      state.itensProcesso = payload
    },
    SET_LIMPAR(state) {
      state.filtroLote = ''
      state.filtroFormulaId = null
      state.filtroSituacao = ''
      state.dt1 = getDataAtual()
      state.dt2 = getDataAtual()
      state.tipoData = 'C'
      state.paginaAtual = 1
    }
  },
  actions: {
    async GET_LISTA(context) {
      const params = {
        lote: context.state.filtroLote,
        formulaId: context.state.filtroFormulaId,
        situacao: context.state.filtroSituacao,
        dt1: context.state.dt1,
        dt2: context.state.dt2,
        tipoData: context.state.tipoData
      }
      const { data } = await axios.get('/api/protected/producao-formula-processo/pesquisar', { params })
      context.commit('SET_LISTA', data)
      return data
    },
    async GET_BY_ID(context, id) {
      const { data } = await axios.get(`/api/protected/producao-formula-processo/getById/${id}`)
      context.commit('SET_PROCESSO_ATUAL', data[0] || null)
      return data[0] || null
    },
    async GET_ITENS(context, processoId) {
      const { data } = await axios.get(`/api/protected/producao-formula-processo-item/listar/${processoId}`)
      context.commit('SET_ITENS_PROCESSO', data)
      return data
    },
    async GET_LOTE_SUGERIDO() {
      const { data } = await axios.get('/api/protected/producao-formula-processo/lote-sugerido')
      return data[0] || null
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/producao-formula-processo-store.js